export function expertiseIdsFromClip(clip) {
	if (!clip) {
		return [];
	}
	if (Array.isArray(clip.expertise_ids) && clip.expertise_ids.length > 0) {
		return clip.expertise_ids.map((id) => Number(id)).filter((id) => !Number.isNaN(id));
	}
	if (Array.isArray(clip.expertises) && clip.expertises.length > 0) {
		return clip.expertises.map((item) => item?.id).filter(Boolean);
	}
	return [];
}

export function expertiseNamesFromClip(clip) {
	if (!clip) {
		return [];
	}
	if (Array.isArray(clip.expertises) && clip.expertises.length > 0) {
		return clip.expertises.map((item) => item?.name).filter(Boolean);
	}
	return [];
}
